import React from 'react';
import { HomeImage, StatsItem } from '../../types/home';
import OptimizedImage from '../about/OptimizedImage';
import CountUp from 'react-countup';

interface StatsSectionProps {
  items: StatsItem[];
  backgroundImage: HomeImage | null;
}

const StatsSection: React.FC<StatsSectionProps> = ({ items, backgroundImage }) => {
  return (
    <section id="stats" className="stats section light-background stats-home">
      <div className="container">
        <div className="row gx-2">
          <div className="offset-sm-1 col-md-10 col-sm-12">
            <div className="row gy-4" data-aos="fade-up" data-aos-delay="100">
              {items.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-6 d-flex flex-column align-items-center">
                  <div className="stats-item">
                    {/* <span 
                      data-purecounter-start="0" 
                      data-purecounter-end= {item.data?.field_description?.[0]?.value} 
                      data-purecounter-duration="1" 
                      className="purecounter"
                    /> */}
                    <CountUp start={0} end={Number(item.data?.field_description?.[0]?.value) || 0} duration={3} />
                    k +
                    <p dangerouslySetInnerHTML={{ __html: item.data?.field_content?.[0]?.value || '' }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Background Image */}
      <div id="truck">
        {backgroundImage && (
          <img
            src={backgroundImage?.thumbnail?.[0]?.url}
            alt="Stats Background"
            loading="lazy"
          />
        )}
      </div>
    </section>
  );
};

export default StatsSection;
